import { GET_ALL_REPORTER_ROLE } from '../../types'

const INITIAL_STATE = {
  getAllReporterRole: [],
}

const reporterRoleReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_REPORTER_ROLE:
      return {
        ...state,
        getAllReporterRole: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default reporterRoleReducer
